import type { FC } from 'react';
import type { CardHeaderProps } from './CardHeader.types';
import styles from './CardHeader.module.css';
import { Flex } from '@/_components';

export const CardHeader: FC<CardHeaderProps> = ({ children }) => {
  return (
    <Flex
      className={styles.cardHeader}
      isColumn={true}
      padding={6}
      isXCentered={true}
    >
      {children}
    </Flex>
  );
};
